// Leaf-модуль без импортов: мост между сетевым слоем (with_refresh) и
// приложением (стор + роутер). Сетевой слой не может импортировать
// Pinia-стор / vue-router напрямую (цикл + не-Vue контекст), поэтому
// сигнал «сессия окончательно потеряна» идёт через этот реестр.
// Обработчик регистрируется один раз при бутстрапе (entrypoints/application.ts).

type SessionHandler = () => void

let expiredHandler: SessionHandler | null = null
let impersonationEndedHandler: SessionHandler | null = null

export function onSessionExpired(h: SessionHandler): void {
  expiredHandler = h
}

// Вызывается из with_refresh, когда refresh не помог восстановить сессию.
// Идемпотентно по дизайну: несколько параллельных 401 могут позвать — обработчик
// сам делает no-op, если уже на /login.
export function emitSessionExpired(): void {
  expiredHandler?.()
}

// Имперсонация оборвалась (E18, §11): запрос под имперсонацией вернул 401
// `impersonation_ended`, refresh успешно вернул админа. Сигнал приложению —
// синхронизировать стор (вернуться к админу), показать тост, уйти на дашборд.
export function onImpersonationEnded(h: SessionHandler): void {
  impersonationEndedHandler = h
}

export function emitImpersonationEnded(): void {
  impersonationEndedHandler?.()
}
